module.exports = __webpack_public_path__ + "44e97d6f3d26c74f7ce2d5c0ad403822.jpg";